import { defaultIAppContext, IAppContext } from "./app-context";

const _sede = {
    data: defaultIAppContext()
};

class Shared {

    get Context(): IAppContext {
        return _sede.data
    }

    set Context(value: IAppContext) {
        _sede.data = value;
    }

    get ProcesoxUrl(): string {
        const server = (window.location.hostname.toLowerCase() === 'localhost') ? 'https://localhost:44329' : _sede.data.ProcesoxUrl;
        return `${server}/api/v1/procesox/${_sede.data.Domain}`;
    }

}

export const Sede = {
    Shared: new Shared()
};
